<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" Style="background-image:url('assets/images/t20-banner-1.png')">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    
                   <div class="vitality-blast-timer">
                        <!-- <div class="team-content-time-box cf">
                            <div class="time-box-content">
                            <p>Day</p> 
                            </div>
                            <div class="time-box-content">
                            <p>Hours</p> 
                            </div>
                            <div class="time-box-content">
                            <p>Minutes</p>
                            </div>
                            <div class="time-box-content">
                            <p>Seconds</p>
                            </div>
                            <countdown class="week-two-timer"></countdown>
                        </div> -->
                            <!-- <countdown class="week-two-timer"></countdown> -->
                        
                      
                   </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="commercial-bottom-content">
            <div class="container">
                <div class="commercial-president-main-section cf">                   
                    <div  class="commercial-president-section cf">
                        <div  class="commercial-president-content-box matchday-car-parking-section cf">
                           <div  class="titel-box">
                              <h2 class="titel-name">{{contentList?.title}}</h2>
                           </div>
                           <!-- <div class="commercial-president-content">
                              <h5>2022 Season Fixtures</h5>
                              <h5>LV=Insurance County Championship Division Two</h5>
                              <ul>
                                  <li><strong> 7 – Sun 10 April -</strong> Leicestershire v Worcestershire</li>
                                  <li><strong>Thurs 21 – Sun 24 April –</strong> Leicestershire v Derbyshire</li>
                                  <li><strong> 12 – Sun 15 May –</strong> Leicestershire v Sussex</li>
                                  <li><strong> 12 – Wed 15 June –</strong> Leicestershire v Nottinghamshire</li>
                                  <li><strong> 20 – Sat 23 July –</strong> Leicestershire v Glamorgan</li>
                                  <li><strong> 12 – Thurs 15 September –</strong> Leicestershire v Durham</li>
                                  <li><strong> 20 – Fri 23 September –</strong> Leicestershire v Middlesex </li>
                              </ul>
                              <h5>Hours of Play</h5>
                              <p>Play begins at 11am and runs to 6pm for all four days with a minimum of 96 overs a day for the first three days, with a minimum of 80 overs on day four. A maximum of 30 minutes of lost time can be made up on each day.</p>                          
                           </div> -->
                           <div class="commercial-president-content" [innerHTML]="contentList?.description">
                              
                           </div>
                           
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
       
    </div>
</section><!-- page ends-->
